import { quickProperty } from '../component-tokens';
export const sizeAttributes = (size, getter = quickProperty) => ({
    height: getter(size),
    width: getter(size),
});
export const nameWithSize = (name, size, additionalProps) => ({
    name,
    attributes: Object.assign(Object.assign({}, sizeAttributes(size)), additionalProps),
});
